export default function PreviewPhoneHero() {
  return (
    <svg width='80' height='80' viewBox='0 0 80 80' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M0 40C0 17.9086 17.9086 0 40 0C62.0914 0 80 17.9086 80 40C80 62.0914 62.0914 80 40 80C17.9086 80 0 62.0914 0 40Z'
        fill='#D2ECFF'
      />
      <g clip-path='url(#clip0_43462_127603)'>
        <path
          d='M45.6879 42.7097C45.861 42.5945 46.0601 42.5243 46.2672 42.5055C46.4743 42.4867 46.6828 42.5198 46.8738 42.6019L54.2426 45.9035C54.4909 46.0096 54.6982 46.1933 54.8334 46.4271C54.9686 46.6609 55.0244 46.9322 54.9926 47.2003C54.7498 49.0145 53.8565 50.6787 52.4786 51.8835C51.1008 53.0883 49.3323 53.7517 47.502 53.7503C41.8661 53.7503 36.4611 51.5115 32.4759 47.5263C28.4908 43.5412 26.252 38.1362 26.252 32.5003C26.2506 30.67 26.914 28.9015 28.1188 27.5237C29.3236 26.1458 30.9878 25.2525 32.802 25.0097C33.0701 24.9778 33.3414 25.0337 33.5752 25.1689C33.809 25.3041 33.9927 25.5114 34.0988 25.7597L37.4004 33.1347C37.4815 33.3241 37.5145 33.5307 37.4966 33.7359C37.4786 33.9412 37.4101 34.1388 37.2973 34.3113L33.9582 38.2816C33.8398 38.4603 33.7697 38.6667 33.7549 38.8806C33.7401 39.0945 33.7811 39.3086 33.8738 39.5019C35.166 42.1472 37.9004 44.8488 40.5535 46.1285C40.7479 46.2208 40.9629 46.2608 41.1775 46.2447C41.392 46.2285 41.5986 46.1567 41.777 46.0363L45.6879 42.7097Z'
          stroke='#195EFF'
          stroke-width='2.5'
          stroke-linecap='round'
          stroke-linejoin='round'
        />
      </g>
      <defs>
        <clipPath id='clip0_43462_127603'>
          <rect width='40' height='40' fill='white' transform='translate(20 20)' />
        </clipPath>
      </defs>
    </svg>
  );
}
